import React, { FC, useState } from 'react';
import { MainTemplate } from '../../components/layouts';
import { DictionaryWrapper } from '../../components/DictionaryWrapper';
import { useSportingEventsQuery } from '../../api';
import { SportingEventsFilter } from '../../components/Filters';
import { Grid, Tooltip } from '@material-ui/core';
import TABLE_OPTIONS from '../../config/tables';
import MUIDataTable, { MUIDataTableColumnDef } from 'mui-datatables';
import { usePermission } from '../../hooks/usePermission';
import { Link, useHistory } from 'react-router-dom';
import { BtnNew } from '../../components/BtnNew';
import { revealEvents } from '../../utils/revealEvents';

const PER_PAGE = 10;

const Page: FC<{}> = () => {
  const [page, setPage] = useState<number>(0);
  const [filter, setFilter] = useState<any>({
    archive: null,
  });
  const { push } = useHistory();
  const access = usePermission('directory', 'classifiers');
  const { data: { dirSportingEvents = [], count = 0 } = {} } = useSportingEventsQuery({
    variables: { skip: page, first: PER_PAGE, filter },
    fetchPolicy: 'no-cache',
  });

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'info',
      label: 'Реестровый номер',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (info) => {
          const { id, registryNumber } = info || {};
          return (
            <React.Fragment>
              <Tooltip title="Перейти в карточку" placement="top-start">
                <Link
                  style={{
                    fontWeight: 500,
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                  to={`/sporting_event/${id}`}
                >
                  {registryNumber}
                </Link>
              </Tooltip>
            </React.Fragment>
          );
        },
      },
    },
    {
      name: 'name',
      label: 'Название мероприятия',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'venue',
      label: 'Место проведения',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'sportTypendDisciplines',
      label: 'Вид спорта/ дисциплины',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'period',
      label: 'период проведения',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'dirNationalTeams.length',
      label: 'Сборных команд',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'athletesCount',
      label: ' Спортсменов',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'athletesCompany',
      label: ' Сопровожд',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'dirCalendar',
      label: 'Календарь',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (status) => <React.Fragment>{status.shortName}</React.Fragment>,
      },
    },

    {
      name: 'status',
      label: 'Статус согласования',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (status) => <React.Fragment>{status.label}</React.Fragment>,
      },
    },
  ];

  return (
    <MainTemplate pageName="Справочник спортивных мероприятий" url="">
      <SportingEventsFilter onSubmit={(filter: any) => setFilter(filter)} />
      <DictionaryWrapper>
        <MUIDataTable
          title={
            <React.Fragment>
              <h2>Справочник спортивных мероприятий</h2>
              <Grid container spacing={1}>
                {access.includes(2) && <Grid item>{<BtnNew onClick={() => push('/sporting_event/new')} />}</Grid>}
              </Grid>
            </React.Fragment>
          }
          data={revealEvents(dirSportingEvents)}
          columns={columns}
          options={{
            ...TABLE_OPTIONS,
            onTableChange: (action, tableState) => {
              switch (action) {
                case 'changePage':
                  setPage(tableState.page);
                  break;
              }
            },
            rowsPerPage: PER_PAGE,
            count,
            page,
          }}
        />
      </DictionaryWrapper>
    </MainTemplate>
  );
};

export default Page;
